import {Component, EventEmitter, inject, Input, Output} from '@angular/core';
import {Button} from "primeng/button";
import {DialogModule} from "primeng/dialog";
import {DropdownModule} from "primeng/dropdown";
import {MessageService, PrimeTemplate} from "primeng/api";
import {
    GroupImageSjcUpdatedDialogControllerService
} from "../../../data/services/group-image-sjc-updated-dialog-controller.service";
import {SJC} from "../../../data/types/groups/types";
import {FormsModule} from "@angular/forms";
import {GroupsService} from "../../../data/services/groups.service";
import {catchError, throwError} from "rxjs";
import {HttpErrorResponse} from "@angular/common/http";
import {UpdateImageCustomSJC} from "../../../data/types/groups/params";

@Component({
    selector: 'app-custom-sjc-dialog',
    standalone: true,
    imports: [
        Button,
        DialogModule,
        DropdownModule,
        PrimeTemplate,
        FormsModule
    ],
    templateUrl: './custom-sjc-dialog.component.html',
    styleUrl: './custom-sjc-dialog.component.css'
})
export class CustomSjcDialogComponent {
    dialogController = inject(GroupImageSjcUpdatedDialogControllerService)
    groupsService = inject(GroupsService)
    messageService = inject(MessageService)

    loading: boolean = false;

    @Input() sjcs: SJC[] = [];

    selectedSjc: SJC | undefined;
    @Output() onImageUpdated = new EventEmitter<boolean>();

    close() {
        this.dialogController.setDialogVisible(false)
    }

    setSelectedCustomSjc(id: number | undefined) {
        if (!id) return this.selectedSjc = undefined;

        for (const sjc of this.sjcs) {
            if (sjc.id === id) {
                this.selectedSjc = sjc;
                break;
            }
        }
    }

    save() {
        if (!this.selectedSjc || !this.dialogController.getSjcGroupImage()) return
        this.loading = true;

        const body = {
            sjc_id: this.selectedSjc.id,
            sjc_group_sjc_inspection_image_id: this.dialogController.getSjcGroupImage()?.sjc_group_sjc_inspection_image_id
        } as UpdateImageCustomSJC

        this.groupsService.updateSjc(body).pipe(
            catchError((error) => this.handleError(error))
        ).subscribe((response) => {
            this.loading = false;
            this.onImageUpdated.emit(true);
            this.close()
            this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail: 'Successfully updated custom SJC'
            });
        })

    }

    handleError(error: HttpErrorResponse) {
        this.loading = false;
        this.messageService.add({severity: 'error', summary: 'Error', detail: 'Failed to update'});
        return throwError(() => new Error('Something bad happened; please try again later.'));
    }
}
